import React from 'react';
import { FaUserMd, FaAmbulance, FaRupeeSign, FaHandsHelping, FaUserNurse, FaSyringe, FaHome, FaVial, FaNotesMedical, FaVideo } from 'react-icons/fa';
import doctorImg1 from '../assets/dr_ps_chaudhary.jpg';
import doctorImg2 from '../assets/mam.jpg';

export default function DoctorInfo() {
  const serviceItems = [
    { icon: <FaHome />, label: 'घर पर Dressing (Small & Large)' },
    { icon: <FaSyringe />, label: 'Stitch Removal' },
    { icon: <FaNotesMedical />, label: 'Catheterization Procedure' },
    { icon: <FaSyringe />, label: 'IV Saline और Injection' },
    { icon: <FaAmbulance />, label: 'Medicine Delivery' },
    { icon: <FaUserNurse />, label: 'Nursing Care' },
    { icon: <FaVial />, label: 'Lab Test' },
    { icon: <FaVideo />, label: 'One-on-One Video Consultation' }
  ];

  const whyChooseUs = [
    { icon: <FaUserMd />, label: 'Trusted care under expert medical guidance' },
    { icon: <FaAmbulance />, label: 'Convenient, on-time home visits' },
    { icon: <FaRupeeSign />, label: 'Affordable pricing with transparent billing' },
    { icon: <FaHandsHelping />, label: 'Support for elderly, immobile & remote patients' },
    { icon: <FaUserNurse />, label: 'Qualified and experienced medical professionals' }
  ];

  return (
    <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-2 sm:p-4 lg:p-6 rounded-xl my-6 sm:my-8">
      <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-center mb-6 sm:mb-8" style={{ color: '#104a5f' }}>
        Meet the Expert Behind Your Health Care
      </h2>

      <div className="flex flex-col lg:flex-row gap-6 lg:gap-8 max-w-7xl mx-auto">
        {/* Doctors Section */}
        <div className="lg:w-1/3 space-y-4 sm:space-y-6">
          {/* Doctor 1 - Dr. P.S. Chaudhary */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src={doctorImg1}
                alt="Dr. P.S. Chaudhary"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="p-3 sm:p-4">
              <h3 className="text-sm sm:text-base lg:text-lg font-bold mb-2" style={{ color: '#104a5f' }}>
                Dr. P.S. Chaudhary / डॉ. पी.एस. चौधरी
              </h3>
              <div className="text-xs sm:text-sm text-gray-700 mb-3 leading-relaxed">
                <p className="font-semibold">M.B.B.S., M.S. (General Surgery)</p>
                <p className="font-semibold">FMAS – Fellowship in Minimal Access Surgery</p>
                <p>Ex. Sr. Resident – Dr. BSA Hospital, Delhi</p>
                <p>Ex. Sr. Resident – BMIMS, Pawapuri</p>
              </div>
              <p className="text-xs sm:text-sm font-bold text-red-700">
                जनरल, मूत्र रोग और लैप्रोस्कोपिक सर्जन
              </p>
            </div>
          </div>

          {/* Doctor 2 - Dr. Sanghmitra Kumari */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
            <div className="aspect-[4/3] overflow-hidden">
              <img
                src={doctorImg2}
                alt="Dr. Sanghmitra Kumari"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="p-3 sm:p-4">
              <h3 className="text-sm sm:text-base lg:text-lg font-bold mb-2" style={{ color: '#104a5f' }}>
                Dr. Sanghmitra Kumari / डॉ. संघमित्रा कुमारी
              </h3>
              <div className="text-xs sm:text-sm text-gray-700 mb-3 leading-relaxed">
                <p className="font-semibold">M.B.B.S., M.S., Obs & Gynae</p>
                <p className="font-semibold">PMCH, Patna</p>
                <p>Ex. Senior Resident, ESI PGI MSR Delhi</p>
                <p>Ex. Senior Resident, BMIMS, Pawapuri</p>
              </div>
              <p className="text-xs sm:text-sm font-bold text-red-700">
                स्त्री, प्रसूति एवं बांझपन रोग विशेषज्ञ
              </p>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="lg:w-2/3 space-y-6">
          {/* About Section */}
          <div className="space-y-4">
            <p className="text-sm sm:text-base lg:text-lg text-gray-700 leading-relaxed">
              With over 26 years of combined experience in the medical field, Dr. P.S. Chaudhary (General & Laparoscopic Surgery) 
              and Dr. Sanghmitra Kumari (Obstetrics & Gynecology) have launched this dedicated home care service platform to bring 
              affordable and essential healthcare directly to patients' homes.
            </p>

            <p className="text-sm sm:text-base lg:text-lg text-gray-700 leading-relaxed">
              Their mission is to bridge the gap between hospital-level expertise and patients' daily needs by offering safe, professional,
              and timely medical services at home. Whether you're recovering from surgery, managing pregnancy care, dealing with gynecological issues,
              or need urgent wound care, our expert team ensures a seamless experience from diagnosis to recovery.
            </p>

            <p className="text-sm sm:text-base lg:text-lg text-gray-700 leading-relaxed">
              This initiative aims to especially help elderly, immobile, pregnant women, and remote-area patients who otherwise face difficulty reaching clinics.
              With trusted service and compassionate care, comprehensive healthcare is now just a doorstep away.
            </p>
          </div>

          {/* Services Section */}
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
            {/* Home Services */}
            <div className="bg-white rounded-xl p-4 sm:p-6 shadow-md">
              <h4 className="text-base sm:text-lg lg:text-xl font-bold mb-4" style={{ color: '#104a5f' }}>
                Home Services Available:
              </h4>
              <ul className="space-y-3">
                {serviceItems.map((item, index) => (
                  <li
                    key={index}
                    className="flex items-center text-xs sm:text-sm lg:text-base text-gray-700 hover:text-gray-900 transition-colors duration-200 hover:transform hover:scale-105 cursor-default"
                  >
                    <span className="mr-3 text-lg" style={{ color: '#104a5f' }}>
                      {item.icon}
                    </span>
                    <span className="leading-relaxed">{item.label}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Why Choose Us */}
            <div className="bg-white rounded-xl p-4 sm:p-6 shadow-md border-l-4" style={{ borderColor: '#104a5f' }}>
              <h4 className="text-base sm:text-lg lg:text-xl font-bold mb-4" style={{ color: '#104a5f' }}>
                Why Choose Our Home Medical Services?
              </h4>
              <ul className="space-y-3">
                {whyChooseUs.map((item, index) => (
                  <li
                    key={index}
                    className="flex items-center text-xs sm:text-sm lg:text-base text-gray-700 hover:text-gray-900 transition-colors duration-200 hover:transform hover:scale-105 cursor-default"
                  >
                    <span className="mr-3 text-lg" style={{ color: '#104a5f' }}>
                      {item.icon}
                    </span>
                    <span className="leading-relaxed">{item.label}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile-specific enhancements */}
      <div className="mt-6 sm:mt-8 lg:hidden">
        <div className="bg-white rounded-xl p-4 shadow-md text-center">
          <p className="text-xs sm:text-sm text-gray-600 italic">
            📱 Swipe through our services or tap any service item for more details
          </p>
        </div>
      </div>
    </div>
  );
}